import React from 'react';
import { Pie } from 'react-chartjs-2';

import { AnglesType } from '../types';
import { diagnosticColors } from '@/constants/Reba';
interface IPieChartProps {
	scores: AnglesType;
}

export const PieChart: React.FC<IPieChartProps> = ({ scores }) => {
	const data = {
		datasets: [
			{
				backgroundColor: diagnosticColors,
				borderColor: diagnosticColors,
				borderWidth: 1,
				data: scores,
				datalabels: {
					display: false
				}
			}
		]
	};
	return <Pie data={data} />;
};
